import { RESET_LAUNCH, SET_SAML_BODY, SET_SAML_METHOD, SET_REDIRECT_AFTER_SIGNIN } from '@app/store/constants';

export function resetLaunch() {
    return {
        type: RESET_LAUNCH
    };
};

export function setSamlMethod(method: string) {
    return {
        payload: method,
        type: SET_SAML_METHOD
    };
};

export function setSamlBody(body: string) {
    return {
        payload: body,
        type: SET_SAML_BODY,
    };
};

export function setRedirectAfterSignin(route: string) {
    return {
        payload: route,
        type: SET_REDIRECT_AFTER_SIGNIN,
    };
};